// PAGINATION STORE
export const PAGE_DEFAULT = 1;
export const LIMIT_DEFAULT = 10;

export const MAX_LIMIT = 300;

export const APP_VERSION = "1.1.96";
